import { useState } from 'react';
import { ExpandMore } from '@material-ui/icons';
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Grid,
  Box,
} from '@material-ui/core';
import { TitleDivider } from '../common/titleDivider';
import { brokerTypeOptions, createRadioField } from '@roc/ui';
import { observer } from 'mobx-react';
import { yesNoOptionsBoolean } from '@roc/feature-utils';
import { useBaseStore, useUserStore } from '@roc/feature-app-core';
import { Switch } from '@material-ui/core';
import { makeStyles, Typography } from '@material-ui/core';
import { CurrencyField } from '@roc/ui';
import { useEffect } from 'react';
import { PercentagePicker } from './leverageComponents';
import { IQuoteTypeStore } from '../../stores/common/iQuoteTypeStore';

const useStyles = makeStyles(theme => ({
  label: {
    fontWeight: 'bold',
    fontSize: '1rem',
  },
  activeLabel: {
    color: theme.palette.primary.main,
  },
  inactiveLabel: {
    color: theme.palette.text.secondary,
  },
  noBorders: {
    border: 'none',
  },
  disabled: {
    background: '#eee',
  },
  feeLabel: {
    fontSize: '14px',
    color: '#939494',
  },
  CurrencyField: {
    '& .MuiInputBase-input': {
      textAlign: 'right',
      fontSize: '20px!important',
      fontWeight: 'bold !important',
      color: false,
    },
    '& .MuiTypography-colorTextSecondary': {
      color: false,
      fontWeight: 'bold',
    },
  },
}));

interface BrokerAccordionProps {
  store: IQuoteTypeStore;
}

export const BrokerAccordion = observer(({ store }: BrokerAccordionProps) => {
  const { loanEconomicsStore } = store;
  const { loanEconomicsFormStore } = loanEconomicsStore;
  const { globalStore } = useBaseStore();
  const { userStore } = useUserStore();
  const [expanded, setExpanded] = useState(true);
  const classes = useStyles();
  const hasBroker = loanEconomicsFormStore.form.fields.hasBroker.value === true;

  return (
    <Accordion
      expanded={expanded}
      onChange={(e, expanded) => setExpanded(expanded)}
      elevation={0}
    >
      <AccordionSummary
        expandIcon={<ExpandMore fontSize="large" />}
        aria-controls="broker-accordion"
      >
        <TitleDivider title="Broker" />
      </AccordionSummary>
      <AccordionDetails>
        <Grid container spacing={2}>
          <Grid item xs={12} md={4} sm={6}>
            {createRadioField({
              label: 'Is there a broker involved in this loan?',
              fieldName: 'hasBroker',
              testId: 'hasBroker',
              options: yesNoOptionsBoolean,
              store: loanEconomicsFormStore,
              row: true,
              standaloneLabel: false,
              onChange: (value: any) => {
                loanEconomicsFormStore.onFieldChange(
                  'hasBroker',
                  value === true || value === 'true'
                );
                loanEconomicsFormStore.onFieldChange('brokerPoints', 0);
              },
            })}
          </Grid>
          {hasBroker && (
            <Grid item xs={12} md={4} sm={6}>
              <PercentagePicker
                fieldName={'brokerPoints'}
                label="Broker Points *"
                value={loanEconomicsFormStore.form.fields.brokerPoints.value}
                min={0}
                max={100}
                onChange={(value: number) =>
                  loanEconomicsFormStore.onFieldChange('brokerPoints', value)
                }
              />
            </Grid>
          )}
        </Grid>
      </AccordionDetails>
    </Accordion>
  );
});
